// Import all required modules
import Accordion from '@bs/components/views/Accordion';
import Cards from '@bs/components/views/Cards';
import Carousel from '@bs/components/views/Carousel';
import DesktopMenuDropdown from '@bs/components/views/DesktopMenuDropdown';
import Dropdown from '@bs/components/views/Dropdown';
import Header from '@bs/components/views/Header';
import InViewport from '@bs/components/views/InViewport';
import SocialShare from '@bs/components/views/SocialShare';
import StatCounter from '@bs/components/views/StatCounter';
import TableOfContentsTabs from '@bs/components/views/TableOfContentsTabs';
import Tabs from '@bs/components/views/Tabs';
import VideoYoutube from '@bs/components/views/VideoYoutube';
import ResearchSidebarFilters from '@bs/components/views/ResearchSidebarFilters';
import JobsSidebarFilters from '@bs/components/views/JobsSidebarFilters';
import FeaturedJobsCarousel from '@bs/components/views/FeaturedJobsCarousel';

// Export reference to all modules in an object
export default {
  Accordion,
  Cards,
  Carousel,
  Dropdown,
  DesktopMenuDropdown,
  Header,
  InViewport,
  SocialShare,
  StatCounter,
  ResearchSidebarFilters,
  TableOfContentsTabs,
  Tabs,
  VideoYoutube,
  JobsSidebarFilters,
  FeaturedJobsCarousel
};
